import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { Subject, takeUntil, debounceTime, merge } from "rxjs";

import { MultiSelectModule } from "primeng/multiselect";

import {
  STATUS_FILTER_OPTIONS,
  TRIGGERED_BY_FILTER_OPTIONS,
} from "../../constants/retention-workflow.constants";

export interface RetentionWorkflowsFilterForm {
  status: FormControl<string[]>;
  actionTrigger: FormControl<number[]>;
}

@Component({
  selector: "app-retention-workflows-filters",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MultiSelectModule],
  templateUrl: "./retention-workflows-filters.component.html",
  styleUrl: "./retention-workflows-filters.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RetentionWorkflowsFiltersComponent implements OnInit, OnDestroy {
  @Input() filterForm!: FormGroup<RetentionWorkflowsFilterForm>;
  @Input() loading = false;

  @Output() filtersChanged = new EventEmitter<void>();

  private readonly destroy$ = new Subject<void>();

  readonly statusOptions = STATUS_FILTER_OPTIONS;
  readonly triggeredByOptions = TRIGGERED_BY_FILTER_OPTIONS;

  ngOnInit(): void {
    this.setupFormSubscriptions();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setupFormSubscriptions(): void {
    if (!this.filterForm) return;

    // Emit filtersChanged after debounce when either control changes
    merge(
      this.filterForm.controls.status.valueChanges,
      this.filterForm.controls.actionTrigger.valueChanges,
    )
      .pipe(debounceTime(300), takeUntil(this.destroy$))
      .subscribe(() => {
        this.filtersChanged.emit();
      });
  }
}
